// ==========================================================================
// News module
// ==========================================================================
import AbstractModule from './AbstractModule';
import {selectricDecorator} from '../ractive/ractive-decorators-selectric';
import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';
import {$document, $body} from '../utils/environment';

export default class extends AbstractModule {

    constructor(options) {
        super(options);

        this.$el           = options.$el;
        this.currentNewsId = options.id;
        this.$filters      = this.$el.find('.js-filters');

        // Ractive style.
        this.template  = null;
        this.partials  = null;
        this.$document = $document;

        // Don'T load twice.
        this.fetchingTemplate = false;

        // News list loaded.
        this.news = [];
        this.currentNews;
        this.loadedNews  = {};
        this.nextPage    = 1;
        this.filtered    = false;
        this.category    = '';
        this.month       = '';
        this.year        = $('.js-filters[name=year]').find(':selected').val();
        this.currentYear = $('.js-filters[name=year]').find(':selected').val();


        this.firstLoad = true;

        // Cached news
        this.newsCache = {};

        // Ractive instance
        this.ractiveInstance = null;

        this.init();
        this.fetchNews(this.currentNewsId, () => {
            if (!this.currentNews) {
                return false;
            }

            window.history.replaceState(this.currentNews, this.currentNews.title, this.currentNews.url);
            this.displayNews(() => {
                this.loaded();
            });
        });
    }

    renderNews(id, url) {
        if (!id) {
            return;
        }

        this.loading();

        this.fetchNews(id, () => {
            if (!this.currentNews) {
                return false;
            }

            window.history.pushState(this.currentNews, this.currentNews.title, this.currentNews.url);
            this.displayNews(() => {
                this.loaded();
            });
        });

        window.App.initModules(this.$el);

        return false;
    }

    init() {
        if (window.matchMedia('(min-width: 999px)').matches) {
            this.newsScrollTop();
        }

        this.$el.on('click.NewsList', '.js-news', (e) => {
            e.preventDefault();
            let $element = $(e.currentTarget);
            if (!$element.data('id')) {
                return false;
            }

            let id  = $element.data('id');
            let url = $element.attr('href');

            this.renderNews(id, url);
        });

        window.onpopstate = (event) => {
            this.loading();
            this.currentNews = event.state;
            this.displayNews(() => {
                this.loaded();
            });
        };

        let self = this;

        this.$el.on('click.NewsList', '.js-load-more', () => {
                self.fetchNewsList(self.addToList.bind(self));
            }
        );


        this.$el.on('change.NewsList', '.js-filters', (e) => {
            let $element = $(e.currentTarget);
            let index    = this.$filters.index($(e.currentTarget));
            let val      = $element.find(':selected').val();

            switch (index) {
                case 0:
                    this.category = val;
                    break;

                case 1:
                    this.year = val;
                    break;

                case 2:
                    this.month = val;
                    break;
            }

            this.filterList();
        });
    }

    initRactive() {

        this.loading();
        if (!this.news || (!this.news.length && this.nextPage == 1)) {
            this.fetchNewsList(this.initRactive.bind(this));
            return this;
        }

        if (!this.template) {
            this.fetchTemplate(this.initRactive.bind(this));
            return this;
        }

        if (this.ractiveInstance) {
            this.loaded();
            return this;
        }


        let self             = this;
        let domList          = this.$el.find('.js-news-list');
        this.ractiveInstance = new Ractive({
            el         : domList,
            template   : this.template,
            partials   : this.partials,
            events     : {tap},
            transitions: {fade},
            decorators : {
                selectric: selectricDecorator
            },

            data    : {
                newsList   : this.news,
                currentNews: this.currentNews,
                loading    : false
            },
            oninit  : function (options) {
            },
            onrender: () => {
                self.loaded();
            }
        });
    }

    // Display a new list when filter changes
    displayList() {
        // Show load-more button
        this.$el.find('.js-load-more').removeClass('is-hidden');

        if (!this.ractiveInstance) {
            this.initRactive();
            return false;
        }

        // set news
        this.ractiveInstance.set('newsList', this.news);

        if (this.news.length) {
            this.ractiveInstance.set('newsList.0.selected', true);
            let id = this.ractiveInstance.get('newsList.0').id;
            this.renderNews(id);
        } else {
            this.currentNews = this.fakeNews;
            this.displayNews();
        }
    }

    // Display single news
    displayNews(cb) {
        if (!this.ractiveInstance) {
            this.initRactive();
            return false;
        }

        if (!this.currentNews) {
            return false;
        }

        setTimeout(() => {
            this.ractiveInstance.set('currentNews', this.currentNews).then(() => {
                if (typeof cb == 'function') {
                    cb();
                }
            });
        }, 600);

        // Update selected news list class
        this.ractiveInstance.set('newsList.*.selected', false);

        // this.ractiveInstance.set(news + '.selected', true);
        let newsList = this.ractiveInstance.get('newsList');

        for (var i = 0; i < newsList.length; i++) {
            if (newsList[i].id == this.currentNews.id) {
                this.ractiveInstance.set('newsList.' + i + '.selected', true);
            }
        }
    }

    // Add news to existing list
    addToList() {
        if (this.news.length) {
            // add news
            for (let news in this.news) {
                if (this.news.hasOwnProperty(news)) {
                    this.ractiveInstance.push('newsList', this.news[news]);
                }
            }
        } else {
            // Hide load-more button
            this.$el.find('.js-load-more').addClass('is-hidden');
        }
    }

    // When a filter is selected
    filterList() {

        let currentYear = this.currentYear || new Date().getFullYear();

        // Each filter case scenarios
        if (!this.category && !this.month && this.year === currentYear) {
            if (!this.filtered) {
                return;
            }
            this.filtered = false;
        }

        if (this.category || this.year !== currentYear || this.month) {
            this.filtered = true;
        }

        // Check cache
        let cache = this.getFromCache(this.category, this.month, this.year);

        if (typeof cache !== 'undefined') {
            this.news     = cache.news;
            this.nextPage = cache.next;
            this.displayList();
        } else {
            this.nextPage = 1;
            this.fetchNewsList(this.displayList.bind(this));
        }
    }

    fetchNewsList(cb) {
        let self = this;

        let cat   = this.category;
        let month = this.month;
        let year  = this.year;
        let page  = this.nextPage;

        let data = {
            category: cat,
            month   : month,
            year    : year,
            page    : page
        };

        $.get('news', data, (response) => {
            if (response.success) {
                this.news     = response.news;
                this.fakeNews = response.fakeNews;
                this.nextPage += 1;

                // Handle cache
                let cache = this.getFromCache(cat, month, year);
                if (cache) {
                    window['secretcache'] = cache;
                    window['cachenews'] = cache.news;
                }

                let newsToCache = (typeof cache != 'undefined') ? cache.news.concat(self.news) : self.news;

                let toCache = {
                    news: newsToCache,
                    next: self.nextPage
                };

                this.addToCache(cat, month, year, toCache);

                if (typeof cb === 'function') {
                    cb();
                }
            }

        }, 'json')
    }

    fetchNews(id, cb) {
        if (typeof this.loadedNews[id] == 'object') {
            this.currentNews = this.loadedNews[id];
            if (typeof cb === 'function') {
                cb();
            }
            return this;
        }

        let data = {
            id: id
        };
        $.get('news', data, (response) => {
            if (response.success) {
                this.currentNews = response.news;
                if (typeof cb === 'function') {
                    cb();
                }
            }

        }, 'json');

        return this;
    }

    fetchTemplate(cb) {
        if (this.template) {
            return this;
        }

        if (this.fetchingTemplate) {
            return this;
        }

        this.fetchingTemplate = true;

        $.get('template', {template: 'volleyball/template/partial/news-list'}, (response) => {
            this.fetchingTemplate = false;
            if (response.success) {
                this.template = response.template;
                this.partials = response.partials;
                if (typeof cb === 'function') {
                    cb();
                }
            }
        }, 'json');

        return this;
    }

    // Cache

    addToCache(cat, month, year, data = null) {

        let key = cat.toString() + '-'
            + month.toString() + '-'
            + year.toString() + '-';

        window['cachekey'] = key;

        if (!data) {
            return key;
        }

        this.newsCache[key] = data;
    }

    getFromCache(cat, month, year) {
        let key = cat.toString() + '-'
            + month.toString() + '-'
            + year.toString() + '-';

        return this.newsCache[key];
    }

    // Trigger loading animation and styles
    loading() {

        this.$el.addClass('is-loading');

        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', true);
        }

        if (!this.firstLoad) {
            $document.trigger({
                type: 'rebuild.Sticky'
            });
        }

        $document.trigger('close.ArticleNavigation');

    }

    // Trigger loaded animation and styles
    loaded() {

        if (!this.firstLoad) {
            $document.trigger({
                type  : 'goTo.Scroll',
                target: '.js-selectors'
            });

        }

        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', false);
        }

        window.App.initModules(self.$el);

        setTimeout(() => {
            $document.trigger({
                type     : 'rebuild.Scroll',
                scrollTop: false
            });
            this.$el.removeClass('is-loading');
        }, 600);

        this.firstLoad = false;

    }

    newsScrollTop() {
        setTimeout(() => {
            $document.trigger({
                type  : 'goTo.Scroll',
                target: $('#js-topbar-selectors')
            });
        }, 3800);
    }

    destroy() {
        if (this.ractiveInstance) {
            this.ractiveInstance.teardown();
        }
        this.$el.off('.NewsList');
    }
}
